// extracted by css-extract-rspack-plugin
export default {"cls1":"ResearchExamples-cls1_1MM","cls2":"ResearchExamples-cls2_wJC ResearchExamples-cls1_1MM","active":"ResearchExamples-active__WV"};